document.addEventListener('dealerLocator:search', e => {
  window.dataLayer.push({
    event: 'dealer_locator_search',
    customerId: window.__VPV.customerId,
    dealer_locator: {
      ...e.detail,
    },
  });
});

document.addEventListener('dealerLocator:filter', e => {
  window.dataLayer.push({
    event: 'dealer_locator_filter',
    dealer_locator: {
      ...e.detail,
    },
  });
});

document.addEventListener('dealerLocator:contact', e => {
  window.dataLayer.push({
    event: 'dealer_locator_contact',
    dealer_locator: {
      contact: {
        ...e.detail,
      },
    },
  });
});

document.addEventListener('carousel:view_item', e => {
  window.dataLayer.push({
    event: 'carousel_view_item',
    carousel: {
      ...e.detail,
    },
  });
});

document.addEventListener('carousel:scroll_to', e => {
  window.dataLayer.push({
    event: 'carousel_scroll_to',
    carousel: {
      ...e.detail,
    },
  });
});

document.addEventListener('carousel:slide_to', e => {
  window.dataLayer.push({
    event: 'carousel_slide_to',
    carousel: {
      ...e.detail,
    },
  });
});

document.addEventListener('search:predictive', e => {
  window.dataLayer.push({
    event: 'search_predictive',
    search_term: e.detail,
  });
});

window.addEventListener('vehicleSubmitted', e => {
  const { make, model, year } = e.detail;
  window.dataLayer.push({
    event: 'vehicle_picker_submit',
    vehicle_make: make,
    vehicle_model: model,
    vehicle_year: year,
  });
});

window.addEventListener('variantSelected', e => {
  const { detail } = e;
  if (detail) {
    const currency = Shopify?.currency?.active;
    const productType = detail.product.productType === 'Decked' ? 'Drawers' : detail.product.productType;
    const dataLayerObj = {
      event: 'select_item',
      ecommerce: {
        currency,
        items: [
          {
            item_category: productType,
            item_type: productType,
            item_name: detail.product?.title,
            item_id: detail.id,
            price: detail.priceV2?.amount,
            item_variant: detail.title,
            item_sku: detail.sku,
            quantity: 1,
            currency,
          },
        ],
      },
    };
    window.dataLayer.push(dataLayerObj);
  }
});

document.addEventListener("variant:add", e => {
  const { items } = e.detail;
  trackCustomAddToCartEvent(items);
});
document.addEventListener("customizer:variant:add", e => {
  const { item } = e.detail;
  trackCustomAddToCartEvent([item]);
});

const trackCustomAddToCartEvent = (items) => {
  if (items.length > 0) {
    const currency = Shopify?.currency?.active;

    const vehicle = VehicleData?.getSelectedVehicle();

    const dataLayerObj = {
      event: "custom_add_to_cart",
      ecommerce: {
        currency,
        items: items.map(item => {
          return {
            item_category: item.product_type,
            item_type: item.product_type,
            item_name: item.product_title,
            item_photo: item.image,
            item_id: item.variant_id,
            price: (item.price / 100).toFixed(2),
            item_brand: item.vendor,
            item_variant: item.variant_title,
            item_sku: item.sku,
            quantity: item.quantity || 1,
            source: item.source,
            vehicle_make: vehicle?.make,
            vehicle_model: vehicle?.model,
            vehicle_year: vehicle?.year,
            vehicle_body_style: vehicle?.body_style,
            vehicle_bed_length: vehicle?.bed_length
          }
        })
      },
    };
    window.dataLayer.push(dataLayerObj);
  }
}


const cartDrawerEl = document.getElementById('cart-drawer');
if(cartDrawerEl){
  cartDrawerEl.addEventListener('toggle', e => {
    const event = e.target.open ? 'mini_cart_open' : 'mini_cart_close';
    window.dataLayer.push({
      event,
    });
  });
}
